import React from 'react'
import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'
import { Link } from 'gatsby'
import Close from 'icons/button_close.svg'

export const Wrapper = styled.div`
  .cookies-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${calculateResponsiveSize(12)} ${calculateResponsiveSize(90)} ${calculateResponsiveSize(12)} ${calculateResponsiveSize(104)};
    font-size: ${calculateResponsiveSize(14)};
    color: #F8F0E6;
    line-height: 1;
    background: #000000;
    opacity: 0;
    visibility: hidden;
    transform: translateY(150%);
    transition: opacity 1s, transform 1s;
    z-index: 1000;
  }
  &.show {
    .cookies-banner {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
  .cookies-banner-accept-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${calculateResponsiveSize(30)};
    padding: 0 ${calculateResponsiveSize(18)};
    text-decoration: none !important;
    font-size: ${calculateResponsiveSize(10)};
    color: #F8F0E6;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    border: 1px solid #F8F0E6;
    background: #000000;
    transition: color 0.25s, background 0.25s;
    cursor: pointer;
    &:hover {
      color: #000000;
      background: #F8F0E6;
    }
  }
  ${mediaMax('mobile')} {
    .cookies-banner {
      padding: ${calculateMobileResponsiveSize(12)} ${calculateMobileResponsiveSize(50)} ${calculateMobileResponsiveSize(12)} ${calculateMobileResponsiveSize(24)};
      font-size: ${calculateMobileResponsiveSize(14)};
    }
    .cookies-banner-accept-btn {
      height: ${calculateMobileResponsiveSize(30)};
      padding: 0 ${calculateMobileResponsiveSize(18)};
      font-size: ${calculateMobileResponsiveSize(10)};
    }
  }
`

export const Content = styled.div``

export const LinkItem = styled((props) => <Link {...props} />)`
  text-decoration: none;
  color: #F8F0E6;
  &:hover {
    text-decoration: underline;
  }
`

export const ButtonClose = styled.div`
  position: absolute;
  top: 50%;
  right: ${calculateResponsiveSize(30)};
  width: ${calculateResponsiveSize(18)};
  height: ${calculateResponsiveSize(18)};
  transform: translateY(-50%);
  background: url(${Close}) center center no-repeat;
  background-size: ${calculateResponsiveSize(16)};
  transition: background-size 0.25s;
  cursor: pointer;
  &:hover {
    background-size: ${calculateResponsiveSize(18)};
  }
  ${mediaMax('mobile')} {
    right: ${calculateMobileResponsiveSize(16)};
    width: ${calculateMobileResponsiveSize(18)};
    height: ${calculateMobileResponsiveSize(18)};
    background-size: ${calculateMobileResponsiveSize(16)};
    &:hover {
      background-size: ${calculateMobileResponsiveSize(18)};
    }
  }
`
